import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getProjectStatisticsYear } from 'apis/dashboard.api';

const useGetProjectStatisticsYear = (params, conds) => {
  const { data: projectStatisticsYear, ...rest } = useQuery(
    ['projectStatisticsYear', params],
    () => getProjectStatisticsYear(params),
    {
      ...conds,
    }
  );

  const data = useMemo(() => projectStatisticsYear?.data ?? [], [projectStatisticsYear]);

  return {
    data,
    ...rest,
  };
};

export default useGetProjectStatisticsYear;
